import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '@/layout'
import AdminLayout from '@/layout/admin'
import SubLayout from '@/layout/vab-content'

export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    meta: {
      title: 'Home',
      affix: true,
    },
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import('@/views/index'),
        meta: {
          title: 'Home',
          model: 'user',
          affix: true,
        },
      },
      {
        path: 'notification',
        name: 'Notification',
        hidden: true,
        component: () => import('@/views/notification'),
        meta: {
          title: 'Notification',
        },
      },
      // {
      //   path: 'privacy',
      //   name: 'Privacy Notice',
      //   component: () => import('@/views/privacy/index'),
      //   hidden: true,
      //   meta: {
      //     title: 'Privacy Notice for the use of the “PROJECT ROAR“',
      //     model: 'empty',
      //   },
      // },
    ],
  },
  {
    path: '/login',
    component: () => import('@/views/login'),
    hidden: true,
  },
  {
    path: '/register',
    component: () => import('@/views/register'),
    hidden: true,
  },
  {
    path: '/resetpwd',
    component: () => import('@/views/resetpwd'),
    hidden: true,
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/views/403'),
    hidden: true,
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404'),
    hidden: true,
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Layout,
    hidden: true,
    redirect: '/privacy/index',
    meta: {
      title: 'Privacy',
    },
    children: [
      {
        path: 'index',
        name: 'Privacy Notice',
        component: () => import('@/views/privacy/index'),
        meta: {
          title: 'Privacy Notice for the use of the “PROJECT ROAR”',
          // title: 'privacy.Privacy Notice for the use of the “PROJECT ROAR”',
          model: 'empty',
        },
      },
    ],
  },
  {
    path: '/me',
    component: Layout,
    redirect: '/me/application',
    name: 'Me',
    meta: {
      title: 'Me',
      roles: ['a'],
    },
    children: [
      {
        path: 'application',
        name: 'My Application',
        component: () => import('@/views/application/list'),
        meta: {
          title: 'My Application',
          icon: 'user-change',
          model: 'me/list',
        },
      },
      {
        path: 'application/detail/:id',
        name: 'My Application Detail',
        hidden: true,
        component: () => import('@/views/application/detail'),
        meta: {
          title: 'My Application',
        },
      },
      {
        path: 'application/apply',
        name: 'Apply For ROAR Moment',
        component: () => import('@/views/application/apply'),
        meta: {
          title: 'Apply For ROAR Moment',
          icon: 'rocket',
          model: 'me/apply',
        },
      },
      {
        path: 'application/guide',
        name: 'Young Talent Career Guide',
        hidden: true,
        component: () => import('@/views/application/query'),
        meta: {
          title: 'Young Talent Career Guide and Learning Resource',
          model: 'guide',
        },
      },
    ],
  },
  {
    path: '/teams',
    component: Layout,
    redirect: '/teams/list',
    meta: {
      title: 'My Team',
      roles: ['b'],
    },
    children: [
      {
        path: 'list',
        name: 'My Team Applications',
        component: () => import('@/views/teams/list'),
        meta: {
          title: 'My Team Applications',
          model: 'teams/list',
        },
      },
      {
        path: 'detail/:id',
        title: 'My Team Applications',
        hidden: true,
        component: () => import('@/views/teams/detail'),
        meta: {
          title: 'My Team Applications',
          model: 'teams/details',
        },
      },
    ],
  },
  {
    path: '/group',
    component: Layout,
    redirect: '/group/list',
    meta: {
      title: 'Group List',
      roles: ['c'],
    },
    children: [
      {
        path: 'list',
        name: 'Group List',
        component: () => import('@/views/group/list'),
        meta: {
          title: 'Group List',
          model: 'group/list',
        },
      },
      {
        path: 'detail/:id',
        title: 'Assessment Result',
        hidden: true,
        component: () => import('@/views/group/detail'),
        meta: {
          title: 'Assessment Result',
          model: 'group/details',
        },
      },
    ],
  },
  {
    path: '/master',
    component: AdminLayout,
    redirect: '/master/home',
    meta: {
      title: 'Dashboard',
      roles: ['d'],
    },
    children: [
      {
        path: 'home',
        title: 'Dashboard',
        component: () => import('@/views/admin/index'),
        meta: {
          icon: 'admin-home',
          roles: ['d'],
        },
      },
      {
        path: 'window',
        title: 'ROAR Window',
        component: () => import('@/views/admin/window'),
        meta: {
          title: 'Welcome to Project ROAR',
          icon: 'admin-window',
          roles: ['d'],
        },
      },
      {
        path: 'database',
        component: SubLayout,
        title: 'Database',
        redirect: '/database/employee',
        meta: {
          title: 'Database',
          icon: 'admin-database',
          roles: ['d'],
        },
        children: [
          {
            path: 'employee',
            title: 'Employee',
            component: () => import('@/views/admin/database/employee'),
            meta: {
              title: 'Employee',
            },
          },
          {
            path: 'guide',
            title: 'Career Guide',
            component: () => import('@/views/admin/database/guide'),
            meta: {
              title: 'Career Guide',
            },
          },
        ],
      },

      {
        path: 'permission',
        title: 'Permission',
        component: SubLayout,
        redirect: '/permission/employee',
        meta: {
          title: 'Permission',
          icon: 'admin-permission',
          roles: ['d'],
        },
        children: [
          {
            path: 'employee',
            title: 'Employee',
            component: () => import('@/views/admin/permission/employee'),
            meta: {
              title: 'Employee Permission',
            },
          },
          {
            path: 'employee_detail/:id',
            title: 'Employee',
            component: () => import('@/views/admin/database/employee-detail'),
            hidden: true,
            meta: {
              title: 'Employee',
            },
          },
          {
            path: 'employee_change/:id',
            title: 'Employee',
            component: () => import('@/views/admin/database/employee-change'),
            hidden: true,
            meta: {
              title: 'Role Change',
            },
          },
          {
            path: 'apply_detail/:id',
            title: 'Assessment Result',
            component: () => import('@/views/admin/permission/applyDetail'),
            meta: {
              title: 'Assessment Result',
              model: 'group/details',
            },
            hidden: true,
          },
          {
            path: 'manager',
            title: 'Review Manager',
            component: () => import('@/views/admin/permission/manager'),
            meta: {
              title: 'Review Manager Permission',
            },
          },
          {
            path: 'manager_detail/:id',
            title: 'Manager',
            component: () => import('@/views/admin/permission/manager-detail'),
            hidden: true,
            meta: {
              title: 'Manager',
            },
          },
          {
            path: 'hrbp',
            title: 'HRBP',
            component: () => import('@/views/admin/permission/hrbp'),
            meta: {
              title: 'HRBP Permission',
            },
          },
          {
            path: 'hrbp_detail/:id',
            title: 'HRBP',
            component: () => import('@/views/admin/permission/hrbp-detail'),
            hidden: true,
            meta: {
              title: 'HRBP',
            },
          },
        ],
      },

      {
        path: 'privacy',
        name: 'Admin Privacy Notice',
        component: () => import('@/views/privacy/index'),
        hidden: true,
        meta: {
          title: 'Privacy Notice for the use of the “PROJECT ROAR”',
          model: 'empty',
        },
      },
    ],
  },
]
export const asyncRoutes = [
  {
    path: '/*',
    redirect: '/404',
    hidden: true,
  },
]
const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes,
})

export default router
